import React from "react";
import { PointedText } from "../models";
import { OrdPsalmSection } from "./OrdPsalmSection";

export const OrdPsalm: React.FC<{
    title: string;
    psalmNumber: number;
    sections: {
        verseNumber: number;
        pointedText: PointedText;
        toneId: string;
    }[];
}> = (props) => {
    const { title, psalmNumber, sections } = props;

    return (
        <>
            {sections.map((section, i) => {
                return (
                    <OrdPsalmSection
                        title={
                            i == 0
                                ? title.replace("-100", "-end")
                                : `${title} cont'd`
                        }
                        pointedText={section.pointedText}
                        toneId={section.toneId}
                        key={`${title}-${section.toneId}`}
                        psalmNumber={psalmNumber}
                        firstVerse={section.verseNumber}
                    />
                );
            })}
        </>
    );
};
